module.exports = __webpack_public_path__ + "img/vue-logo.8ee371d2.png";